import React from 'react';
import { trackAddToCart } from '../utils/metaPixel';
import { Section } from './ui/Section';
import { GoldButton } from './ui/GoldButton';
import { Download, Clock, WifiOff } from 'lucide-react';
export function OfferCTA() {
  const handleAddToCart = () => {
    trackAddToCart({
      content_name: 'Kit Apaga la Cabeza',
      content_type: 'product',
      value: 6.39,
      currency: 'EUR'
    });
  };
  return <Section id="oferta" className="text-center" data-id="element-140">
      <div className="bg-[#1e2d3d] p-8 md:p-12 rounded-sm border border-[#c9a04e]/20 shadow-2xl relative overflow-hidden" data-id="element-141">
        {/* Glow effect background */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_top,_var(--tw-gradient-stops))] from-[#c9a04e]/10 via-transparent to-transparent pointer-events-none" data-id="element-142"></div>

        <h2 className="text-3xl md:text-4xl font-serif text-[#f5f0e8] mb-4" data-id="element-143">
          Apaga la Cabeza
        </h2>
        <p className="text-[#8a9bb0] uppercase tracking-widest text-sm mb-8" data-id="element-144">
          Kit de Rescate para Dormir
          <br data-id="element-145" />
          (7 noches)
        </p>

        <div className="mb-8" data-id="element-146">
          <div className="flex items-baseline justify-center gap-3 md:gap-4" data-id="element-147">
            <span className="text-xl md:text-2xl text-[#8a9bb0] line-through font-serif" data-id="element-148">
              19,99€
            </span>
            <span className="text-5xl md:text-6xl font-serif text-[#c9a04e]" data-id="element-149">
              6,39€
            </span>
            <span className="text-lg md:text-xl text-[#c9a04e]/80 font-medium" data-id="element-150">
              -68% OFF
            </span>
          </div>
          <p className="text-[#f5f0e8]/60 mt-2" data-id="element-151">PDF + Imprimibles</p>
        </div>

        <div className="mb-10" data-id="element-152">
          <GoldButton href="https://warame.com/cart/56907511202174:1" onClick={handleAddToCart} className="w-full md:w-auto min-w-[280px]" data-id="element-153">
            Quiero el Kit Apaga la Cabeza
          </GoldButton>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-[#f5f0e8]/70 border-t border-[#f5f0e8]/10 pt-8" data-id="element-154">
          <div className="flex flex-col items-center gap-2" data-id="element-155">
            <Download className="w-5 h-5 text-[#c9a04e]" data-id="element-156" />
            <span data-id="element-157">
              Acceso instantáneo
              <br data-id="element-158" />
              (PDF descargable)
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-159">
            <Clock className="w-5 h-5 text-[#c9a04e]" data-id="element-160" />
            <span data-id="element-161">
              Diseñado para hacerlo
              <br data-id="element-162" />
              en 15 min
            </span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-163">
            <WifiOff className="w-5 h-5 text-[#c9a04e]" data-id="element-164" />
            <span data-id="element-165">
              Sin pantallas,
              <br data-id="element-166" />
              sin misticismo
            </span>
          </div>
        </div>
      </div>
    </Section>;
}